import { SVGAttributes } from 'react';

export function SettingIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width="144px"
      height="130px"
      viewBox="-0.5 -0.5 144 130"
      {...props}
    >
      <defs />
      <g>
        <g data-cell-id="0">
          <g data-cell-id="1">
            <g data-cell-id="43s24t3kMvA4kIPissoO-1" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-3" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-4" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-5" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-7" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-8" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-12" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-13" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-14" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-15" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-16" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-17" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-18" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-19" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-20" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-21" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-22" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-29">
              <g data-cell-id="43s24t3kMvA4kIPissoO-6" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-27" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-9" />
              <g data-cell-id="43s24t3kMvA4kIPissoO-28" />
            </g>
            <g data-cell-id="43s24t3kMvA4kIPissoO-25" />
            <g data-cell-id="43s24t3kMvA4kIPissoO-33">
              <g>
                <rect
                  x="0"
                  y="0"
                  width="144"
                  height="130"
                  fill="none"
                  stroke="none"
                  pointerEvents="all"
                />
                <path
                  d="M 76.36 17.3 L 92.89 2.11 C 94.4 0.81 96.15 0.03 98.24 0 L 135.48 0 C 139.37 0 144 3.24 144 8.75 L 144 17.3 Z M 0 130 L 0 32.27 C 0 27.47 4.31 23.83 8.44 23.83 L 144 23.83 L 144 130 Z"
                  fill="currentColor"
                  stroke="none"
                  pointerEvents="all"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
